import { atom } from 'jotai'
import { Thread } from './model'

export const isShowMobileMenuAtom = atom(false)

export const pendingMessageAtom = atom<string | null>(null)

export const renameThreadIdAtom = atom<string | null>(null)
export const deleteThreadIdAtom = atom<string | null>(null)
export const deleteTemplateIdAtom = atom<string | null>(null)

export const scrollToBottomOfMessageAtom = atom(0)

export const selectedResourcesAtom = atom<Record<string, boolean>>({})
export const appSelectedResourcesAtom = atom<Record<string, boolean>>({})

export const reshowOnboardingAtom = atom<boolean>(false)

export const demoThreadAtom = atom<Thread | null>(null)

export const appSwitcherOpenAtom = atom(false)
